// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InteractionTwoToneSvg from "@fishx/icons-svg/es/asn/InteractionTwoTone";
import FishxIcon from '../components/FishxIcon';

var InteractionTwoTone = function InteractionTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: InteractionTwoToneSvg
  }));
};

InteractionTwoTone.displayName = 'InteractionTwoTone';
export default React.forwardRef(InteractionTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/InteractionTwoTone.js
// module id = 2993
// module chunks = 0